import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import React from 'react'

import { Doughnut } from 'react-chartjs-2'
ChartJS.register(ArcElement, Tooltip, Legend)

const plugins = [
  {
    afterDraw: function (chart) {
      return chart
    },
  },
]

const DoughtChart = ({ labels, chartData }) => {
  const data = {
    labels: labels,
    datasets: [
      {
        data: chartData,
        borderWidth: 0,
        borderRadius: 1,
        cutout: '70%',
        backgroundColor: ['#5DB594', '#E35E50', '#F3A66E', '#3249d7'],
      },
    ],
  }
  return (
    <div className="chart">
      <Doughnut
        data={data}
        width={300}
        height={300}
        plugins={plugins}
        options={{
          plugins: {
            legend: {
              display: true,
              position: 'right',
              labels: {
                usePointStyle: true,
                boxWidth: 6,
                padding: 20,
              },
            },
          },

          maintainAspectRatio: false,
        }}
      />
    </div>
  )
}

export default DoughtChart
